<!-- 劳务公司里的交流按钮 -->
<template>
  <div class="button">
    <div @click.stop="toChat(item)">
      <img style="width:20px;height:20px" src="@/assets/hideBox/jiaoliu.png" alt />
      <span>交流</span>
    </div>
  </div>
</template>

<script>
import axios from "@/http"
import eventBus from "@/utils/event-bus"
import {apiLaborServiceCompany} from "@/api/apiLaborServiceCompany"

export default {
  name: "im",
  inject:['cardListCom'],
  props:{
    item:Object
  },
  data(){
    return {
      loading:false,
      customerList: []
    }
  },
  methods:{
    // 交流
    async toChat() {
      if(this.permissionTips({
        realName:false
      })) 
      return
      let siteNo = this.item.no
      let siteType=this.$store.state.user.type
        apiLaborServiceCompany.getCustomer(siteNo,siteType).then(({ data }) => {
          if ( data.code === 200 ) {
            this.customerList = data.data
            if (this.customerList[0].imAccount) {
                  eventBus.$emit("sendImMessage", this.customerList[0].imAccount)
              } else {
                  this.$message.err("未找到客服人员")
              }
          } else {
            this.$message.error(data.msg)
          }
        }).catch((err) => {
          this.$message.error('客服数据获取失败，请刷新重试')
      })
    },
  },

}
</script>

<style scoped>

</style>
